import { FormSelectConfig } from '/@/modules/core/form/models/FormSelectConfig';
import { SortOrder } from '/@/modules/core/app/constants/SortOrder';
import { orderBy } from 'lodash';

export class EnumFormSelectConfig extends FormSelectConfig {
  /**
   * @var {Enum}
   */
  enumClass;

  /**
   * @var {String}
   */
  sortOrder;

  /**
   * @param {Enum} enumClass
   * @param config
   * @param sortOrder
   */
  constructor(enumClass, config = {}, sortOrder = null) {
    super(config);

    this.enumClass = enumClass;
    this.sortOrder = sortOrder;
  }

  // eslint-disable-next-line no-unused-vars
  getOptions(params = {}) {
    let values = this.getValues();
    values = this.filterVisibleOptions(values);
    values = this.getDisableOptions(values);

    if (this.sortOrder === SortOrder.ASC) {
      return this.sortEnum(values, SortOrder.ASC);
    }
    if (this.sortOrder === SortOrder.DESC) {
      return this.sortEnum(values, SortOrder.DESC);
    }
    return values;
  }

  getValues() {
    return this.enumClass.getValues();
  }

  sortEnum(values, sortOrder) {
    return orderBy(values, ['value'], [sortOrder]);
  }
}
